<!--
Created on 2021-04-17
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-17
-->
<template>
  <div id="page">
    <!-- header and footer bar go here-->
    <div class="header header-fixed header-auto-show header-logo-app">
      <a href="#" class="header-title header-subtitle">Zadajte PIN</a>
      <a href="#" data-toggle-theme class="header-icon header-icon-2 show-on-theme-dark"><i class="fas fa-sun"></i></a>
      <a href="#" data-toggle-theme class="header-icon header-icon-2 show-on-theme-light"><i class="fas fa-moon"></i></a>
    </div>
    <div class="page-content pb-0" style="min-height: 100vh;">
      <div class="page-title page-title-small">
        <h2>Zadajte PIN</h2>
      </div>
      <div class="card header-card shape-rounded" data-card-height="150">
        <div class="card-overlay bg-highlight opacity-95"></div>
        <div class="card-overlay dark-mode-tint"></div>
        <div class="card-bg preload-img" data-src="images/pictures/20s.jpg"></div>
      </div>
      <div class="card card-style">
        <div class="content p-2">
          Pre spustenie aplikácie je potrebné zadať bezpečnostný PIN, ktorý bol vytvorený pre prihlásenie. V prípade, že PIN neviete, je možné sa ODHLÁSIŤ a po prihlásení vytvoriť nový.
        </div>
      </div>
      <div class="card card-style bg-highlight">
        <div class="content pt-1 pb-1">
          <h1 class="mb-1 color-white font-700 text-center">Zadajte PIN</h1>
          <div class="boxed-text-xl color-white opacity-80">
            <div class="keyboard mb-0 mt-4">
              <div class="pin">
                <div class="pin-element" :class="{ 'active': pin.length > 0 }"></div>
                <div class="pin-element" :class="{ 'active': pin.length > 1 }"></div>
                <div class="pin-element" :class="{ 'active': pin.length > 2 }"></div>
                <div class="pin-element" :class="{ 'active': pin.length > 3 }"></div>
              </div>
              <p class="color-white px-2 m-0 mt-n3" >{{ message }}</p>
              <div class="row m-0">
                <div v-for="index in 3" :key="index" class="col-4 p-0 m-0">
                  <div @click="if(pin.length < 4) pin = pin + index;" class="key">{{ index }}</div>
                </div>
              </div>
              <div class="row m-0">
                <div v-for="index in 3" :key="index" class="col-4 p-0 m-0">
                  <div @click="if(pin.length < 4) pin = pin + (index + 3);" class="key">{{ index + 3 }}</div>
                </div>
              </div>
              <div class="row m-0">
                <div v-for="index in 3" :key="index" class="col-4 p-0 m-0">
                  <div @click="if(pin.length < 4) pin = pin + (index + 6);" class="key">{{ index + 6 }}</div>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-4 p-0 m-0">
                  <div @click="if(pin.length > 0) pin = pin.slice(0, -1);" class="key"><i class="fa fa-chevron-left"></i></div>
                </div>
                <div class="col-4 p-0 m-0">
                  <div @click="if(pin.length < 4) pin = pin + '0';" class="key">0</div>
                </div>
                <div class="col-4 p-0 m-0">
                  <div @click="pin = ''" class="key"><i class="fa fa-times"></i></div>
                </div>
              </div>
            </div>
            <button @click.stop.prevent="checkPIN()" class="mt-4 btn close-menu btn-s shadow-l bg-white color-black font-900 btn-center-m mb-2" :disabled="(pin || '').length != 4">{{ btnTitle || 'ĎALEJ' }}</button>
          </div>
        </div>            
      </div>        
      <!--logout card-->
      <div class="card card-style">
        <div class="content p-2">
          <p>
            Ak sa chcete prihlásiť pod iným užívateľom. Musíte sa najprv odhlásiť. Po odhlásení, budú všetky dáta a súkromné informácie zmazané! Dáta, ktoré neboli zosynchronizované sa stratia!
          </p>
          <a href="#" data-menu="menu-logout" class="btn btn-m mt-2 mb-2 btn-full bg-red-dark rounded-sm text-uppercase font-900"><i class="i-loading fa fa-sync fa-spin me-3"></i>Odhlásiť</a>
        </div>
      </div>
      <!-- footer and footer card-->
      <div class="footer" data-menu-load="menu-footer.html"></div>  
    </div>    
    <!-- end of page content-->

    <warning-modal :message="errorMessage" title="Nesprávny PIN!" />

    <!-- modal logout -->
    <div id="menu-logout" class="menu menu-box-modal bg-red-dark rounded-m" 
         data-menu-width="310">
        <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times-circle color-white shadow-xl rounded-circle"></i></h1>
        <h1 class="text-center mt-3 color-white font-700">Odhlásiť?</h1>
        <p class="boxed-text-l color-white opacity-70">
          Po odhlásení budú uložené dáta vymazané:<br>databáza, objednávky a podobne.<br>Naozaj sa chcete odhlásiť?
        </p>
        <a href="login.html" class="close-menu btn btn-m btn-center-m button-s shadow-l mb-4 rounded-s text-uppercase font-900 bg-white color-red-dark">odhlásiť</a>
    </div>
  </div>    
</template>

<script>
import { ref, inject } from 'vue'
import auth from '@/lib/auth'
import WarningModal from '@/components/modals/WarningModal'

export default {
  name: 'EnterPIN',
  components: {
    WarningModal,
  },
  setup() {
    const pin = ref('')
    const message = ref('')
    const errorMessage = ref('')
    const btnTitle = ref('')
    const appProps = inject('appProps')

    function checkPIN () {
      if (auth.authPIN(pin.value, appProps.$cookies)) {
        appProps.$router.push({ name: appProps.$cookies.get('fromName') || 'Home' })
      } else {
        setTimeout(function() {
          errorMessage.value = 'Vložený PIN nebol správny, prosím zadajte PIN znova.'
          appProps.$openWarningModal()
          pin.value = ''
        }, 200)
      }
    }

    return {
      pin,
      btnTitle,
      message,
      errorMessage,
      checkPIN,
    }
  },
  mounted() {
    setTimeout(() => {
      document.init_event()
    })
  },
}
</script>
